import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'

function Help() {
  
  return (
    <div className='bg-white h-100 py-5'>
                                      <AuthNavbar />

      <Container>
        <h4 className='text-center mb-5'>أهلاً بك عزيزي المعلم اختر أداة المساعدة التي تناسبك وتواصل معي مباشرة</h4>
        <Row>
      <Col md={4} className='my-2'>
          <div className='border py-4 rounded'onClick={()=>window.location.href = "tel:+96899355300"}style={{cursor:"pointer"}}>
            <p className='font-weight-bold  text-center mb-2'>رقم الهاتف</p>
              <p className=' text-center mb-2'>99355300</p>
          </div>
          </Col>
      <Col md={4} className='my-2'>
          <div className='border py-4 rounded'onClick={()=>window.open("https://wa.me/96899355300", "_blank")}style={{cursor:"pointer"}}>
            <p className='font-weight-bold  text-center mb-2'>الواتساب</p>
              <p className=' text-center mb-2'>99355300</p>
          </div>
          </Col>
                    <Col md={4}></Col>

      <Col md={4} className='my-2'>
          <div className='border py-4 rounded'onClick={()=>window.location.href = "mailto:abdullah@moe.om"}style={{cursor:"pointer"}}>
            <p className='font-weight-bold  text-center mb-2'>البريد الالكتروني</p>
              <p className=' text-center mb-2'>mailto:abdullah.alhinaei@moe.om</p>
          </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Help